// A cancelled run ends the conversation's lifecycle without a line of its
// own: the reader cancelled it, or saw it stop, and needs no receipt.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({
    reason: z.string().nullable().optional(),
});

export const runCancelledDefinitions = {
    run_cancelled: defineInvisible('run_cancelled', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence(_payload, occurrence) {
            if (occurrence.committed === null) {
                return null;
            }
            return {
                kind: 'run_terminal',
                eventId: occurrence.committed.id,
                occurredAtMs: Date.parse(occurrence.committed.created_at),
            };
        },
    }),
} as const;

export const runCancelledContractFixtures = {
    valid: {
        type: 'run_cancelled',
        reason: 'cancellation-reason-sentinel',
    },
    malformed: {
        type: 'run_cancelled',
        reason: false,
    },
} as const;
